import { render, staticRenderFns } from "./WithData.vue?vue&type=template&id=293e87a8&scoped=true&"
import script from "./WithData.vue?vue&type=script&lang=js&"
export * from "./WithData.vue?vue&type=script&lang=js&"
import style0 from "./WithData.vue?vue&type=style&index=0&id=293e87a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293e87a8",
  null
  
)

component.options.__file = "WithData.vue"
export default component.exports